import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export const isSentryEnabled =
  import.meta.env.PROD &&
  typeof dsn === "string" &&
  dsn.length > 0 &&
  typeof window !== "undefined" &&
  window.location.hostname === "quotedsarrow.com";

if (isSentryEnabled) {
  Sentry.init({
    dsn,
    environment: "production",
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };
